import {GET_LOGIN_REQUESTED, GET_MAGICTOKEN, GET_MAGICTOKEN_REQUESTED, GET_TOKENVERIFY, GET_TOKENVERIFY_REQUESTED} from "resources/actionTypes";

export function getLogin(userLogin,navigate, setOnOtp) {
  const data ={
    userLogin: userLogin,
    navigate:navigate,
    setOnOtp: setOnOtp
  }
  return {
    type: GET_LOGIN_REQUESTED,
    payload: data,
  };
}

export function getMagicToken(userMagicToken) {
  const data ={
    userMagicToken:userMagicToken,
  }
  return {
    type: GET_MAGICTOKEN_REQUESTED,
    payload: data,
  };
}

export function getTokenVerify(userTokenVerify) {
  const data ={
    userTokenVerify:userTokenVerify,
  }
  return {
    type: GET_TOKENVERIFY_REQUESTED,
    payload: data,
  };
}
